import Vue from 'vue'
import * as types from 'store/mutation-types'

const actions = {
  loadHkBriefInfo({ commit, dispatch }, { symbol, market }) {
    const industry = () =>
      Vue.http.get(`~stock/market/plate/belonged/${symbol}`).then(resp => {
        if (resp.data.ret !== 0) {
          return []
        }
        return resp.data.items
      })

    const hkIntro = () =>
      Vue.http.get(`~stock/hkstock/stock_info/profile/${symbol}`).then(resp => {
        if (resp.data.ret !== 0) {
          return {}
        }
        return resp.data.items[0]
      })
    const hkResearch = () =>
      Vue.http
        .get(`~stock/fundamental/hkstock/publicity/research/${symbol}`)
        .then(resp => {
          if (resp.data.ret !== 0) {
            return {}
          }
          return resp.data.data.research
        })
    const hkCrossVolume = () =>
      Vue.http
        .get(`~stock/hkstock/stock_info/hk_cross_volume/${symbol}`)
        .then(resp => {
          if (resp.data.ret !== 0) {
            return []
          }
          return resp.data.items
        })
    const hkFunds = () =>
      Vue.http
        .get(`~stock/hkstock/stock_info/publicity_fund_with_medium/${symbol}`)
        .then(resp => {
          if (resp.data.ret !== 0) {
            return {}
          }
          return resp.data.fund
        })
    const hkOrgHoldings = () =>
      Vue.http
        .get(`~stock/hkstock/stock_info/org_hold/${symbol}`)
        .then(resp => {
          if (resp.data.ret !== 0) {
            return {}
          }
          const { summary, recently } = resp.data
          return {
            holdSummary: summary,
            recently
          }
        })
    const hkBuyback = () =>
      Vue.http.get(`~stock/hkstock/stock_info/buyback/${symbol}`).then(resp => {
        if (resp.data.ret !== 0) {
          return {}
        }
        return resp.data.items
      })

    return Promise.all([
      hkIntro(),
      industry(),
      hkResearch(),
      hkCrossVolume(),
      hkFunds(),
      hkOrgHoldings(),
      hkBuyback()
    ]).then(
      ([intro, industry, research, cross, funds, orgHoldings, buyback]) => {
        return commit(types.LOAD_BRIEF_DATA, {
          intro,
          industry,
          research,
          cross,
          funds,
          orgHoldings,
          buyback
        })
      }
    )
  }
}

export default {
  actions
}
